import { render, staticRenderFns } from "./voluntariado-actividades-carousel.vue?vue&type=template&id=15c6b30b&scoped=true"
import script from "./voluntariado-actividades-carousel.vue?vue&type=script&lang=js"
export * from "./voluntariado-actividades-carousel.vue?vue&type=script&lang=js"
import style0 from "./voluntariado-actividades-carousel.vue?vue&type=style&index=0&id=15c6b30b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6b30b",
  null
  
)

export default component.exports